import * as i0 from '@angular/core';
import { Injectable, InjectionToken, NgModule } from '@angular/core';
import { Config, facadeFactory, provideDefaultConfigFactory, provideDefaultConfig } from '@spartacus/core';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { ORDER_ENTRIES_CONTEXT } from '@spartacus/cart/base/root';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultQuickOrderConfig = {
  quickOrder: {
    searchForm: {
      displayProductImages: true,
      maxProducts: 5,
      minCharactersBeforeRequest: 3
    },
    list: {
      hardDeleteTimeout: 240_000
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let QuickOrderConfig = /*#__PURE__*/(() => {
  class QuickOrderConfig {
    static {
      this.ɵfac = function QuickOrderConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || QuickOrderConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: QuickOrderConfig,
        factory: function QuickOrderConfig_Factory(__ngFactoryType__) {
          let __ngConditionalFactory__ = null;
          if (__ngFactoryType__) {
            __ngConditionalFactory__ = new (__ngFactoryType__ || QuickOrderConfig)();
          } else {
            __ngConditionalFactory__ = i0.ɵɵinject(Config);
          }
          return __ngConditionalFactory__;
        },
        providedIn: 'root'
      });
    }
  }
  return QuickOrderConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CART_QUICK_ORDER_FEATURE = 'cartQuickOrder';
const CART_QUICK_ORDER_CORE_FEATURE = 'cartQuickOrderCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function quickOrderFacadeFactory() {
  return facadeFactory({
    facade: QuickOrderFacade,
    feature: CART_QUICK_ORDER_CORE_FEATURE,
    methods: ['addProduct', 'addToCart', 'clearList', 'canAdd', 'setListLimit', 'getEntries', 'getProductAdded', 'loadEntries', 'softDeleteEntry', 'searchProducts', 'setProductAdded', 'updateEntryQuantity', 'getSoftDeletedEntries', 'restoreSoftDeletedEntry', 'hardDeleteEntry', 'clearDeletedEntries', 'getNonPurchasableProductError', 'setNonPurchasableProductError', 'clearNonPurchasableProductError']
  });
}
let QuickOrderFacade = /*#__PURE__*/(() => {
  class QuickOrderFacade {
    static {
      this.ɵfac = function QuickOrderFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || QuickOrderFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: QuickOrderFacade,
        factory: () => quickOrderFacadeFactory(),
        providedIn: 'root'
      });
    }
  }
  return QuickOrderFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const QuickOrderOrderEntriesContextToken = new InjectionToken('QuickOrderOrderEntriesContext');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultQuickOrderComponentsConfig() {
  const config = {
    featureModules: {
      [CART_QUICK_ORDER_FEATURE]: {
        cmsComponents: ['QuickOrderComponent', 'CartQuickOrderFormComponent']
      },
      // by default core is bundled together with components
      [CART_QUICK_ORDER_CORE_FEATURE]: CART_QUICK_ORDER_FEATURE
    }
  };
  return config;
}
const defaultQuickOrderRoutingConfig = {
  routing: {
    routes: {
      quickOrder: {
        paths: ['my-account/quick-order']
      }
    }
  }
};
let QuickOrderRootModule = /*#__PURE__*/(() => {
  class QuickOrderRootModule {
    static {
      this.ɵfac = function QuickOrderRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || QuickOrderRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: QuickOrderRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultQuickOrderComponentsConfig), provideDefaultConfig(defaultQuickOrderRoutingConfig), provideDefaultConfig(defaultQuickOrderConfig)],
        imports: [RouterModule.forChild([{
          // @ts-ignore
          path: null,
          canActivate: [CmsPageGuard],
          component: PageLayoutComponent,
          data: {
            cxRoute: 'quickOrder',
            cxContext: {
              [ORDER_ENTRIES_CONTEXT]: QuickOrderOrderEntriesContextToken
            }
          }
        }])]
      });
    }
  }
  return QuickOrderRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CART_QUICK_ORDER_CORE_FEATURE, CART_QUICK_ORDER_FEATURE, QuickOrderConfig, QuickOrderFacade, QuickOrderOrderEntriesContextToken, QuickOrderRootModule, defaultQuickOrderComponentsConfig, defaultQuickOrderConfig, defaultQuickOrderRoutingConfig, quickOrderFacadeFactory };
